import React, { useState } from 'react';
import CodeExample from '../components/CodeExample';

const Endpoints = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('javascript');

  const endpoints = [
    {
      method: 'GET',
      path: '/api/public/workspaces',
      description: 'Récupère tous les workspaces accessibles pour l\'utilisateur authentifié',
      requiresAuth: true,
      requiresWorkspace: false,
      params: [],
      response: `{
  "user": {
    "id": 123,
    "email": "user@exemple.com"
  },
  "workspaces": [
    {
      "id": 456,
      "title": "Mon Workspace",
      "role": "admin"
    }
  ]
}`
    },
    {
      method: 'GET',
      path: '/api/api-keys',
      description: 'Liste toutes les API Keys de l\'utilisateur (nécessite authentification JWT classique)',
      requiresAuth: true,
      requiresWorkspace: false,
      note: 'Cet endpoint nécessite un JWT obtenu via /auth (email/password), pas via API Key',
      params: [],
      response: `{
  "api_keys": [
    {
      "id": 1,
      "name": "Ma première API Key",
      "apiKey": "whk_live_xxxx...xxxx",
      "isActive": true,
      "createdAt": "2024-01-15T10:30:00Z"
    }
  ]
}`
    },
    {
      method: 'POST',
      path: '/api/v1/messages/send-template',
      description: 'Envoie un message WhatsApp avec un template approuvé par Meta',
      requiresAuth: true,
      requiresWorkspace: true,
      note: 'Body : to, templateName (obligatoires), language (optionnel), variables (optionnel, tableau positionnel). Scope requis : messages:send',
      params: [],
      response: `{
  "messageId": "wamid.xxxxxx",
  "to": "+33612345678",
  "templateName": "welcome_message",
  "status": "sent"
}`
    }
  ];

  return (
    <div className="page">
      <div className="page-header">
        <h1>📡 Endpoints API</h1>
        <p>
          Documentation complète de tous les endpoints disponibles dans l'API publique WhakUp.
        </p>
      </div>

      <div className="section">
        <h2>🎯 Endpoints Disponibles</h2>
        
        {endpoints.map((endpoint, index) => (
          <div key={index} className="endpoint-card">
            <div className="endpoint-header">
              <span className={`method-badge method-${endpoint.method.toLowerCase()}`}>
                {endpoint.method}
              </span>
              <span className="endpoint-path">{endpoint.path}</span>
            </div>
            <div className="endpoint-description">{endpoint.description}</div>

            {endpoint.requiresAuth && (
              <div className="alert alert-info" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                ⚠️ Nécessite authentification JWT
              </div>
            )}

            {endpoint.requiresWorkspace && (
              <div className="alert alert-info" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                ⚠️ Nécessite header <code>X-Workspace-Id</code>
              </div>
            )}

            {endpoint.note && (
              <div className="alert alert-warning" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                {endpoint.note}
              </div>
            )}

            {endpoint.params && endpoint.params.length > 0 && (
              <>
                <h4>Paramètres:</h4>
                <table className="params-table">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Type</th>
                      <th>Requis</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {endpoint.params.map((param, pIndex) => (
                      <tr key={pIndex}>
                        <td><code>{param.name}</code></td>
                        <td>{param.type}</td>
                        <td>{param.required ? '✅ Oui' : '❌ Non'}</td>
                        <td>{param.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            {endpoint.body && (
              <>
                <h4>Body exemple:</h4>
                <div className="code-block">
                  {endpoint.body}
                </div>
              </>
            )}

            <h4>Réponse:</h4>
            <div className="code-block">
              {endpoint.response}
            </div>
          </div>
        ))}
      </div>

      <div className="section">
        <h2>📋 Headers Communs</h2>
        <table className="params-table">
          <thead>
            <tr>
              <th>Header</th>
              <th>Description</th>
              <th>Requis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>Authorization</code></td>
              <td>Bearer JWT_TOKEN</td>
              <td>Pour les endpoints protégés</td>
            </tr>
            <tr>
              <td><code>X-Workspace-Id</code></td>
              <td>ID du workspace</td>
              <td>Pour les endpoints workspace</td>
            </tr>
            <tr>
              <td><code>Content-Type</code></td>
              <td>application/json</td>
              <td>Pour POST/PUT</td>
            </tr>
            <tr>
              <td><code>X-API-Key</code></td>
              <td>Votre API Key</td>
              <td>Pour /api/public/auth</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Endpoints;
